import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ErrorBoundary, ChunkLoadErrorBoundary } from '@trello/error-reporting';
import type { BoardDescriptionSpotlightProps } from './BoardDescriptionSpotlight';

export const LazyBoardDescriptionSpotlight: FunctionComponent<BoardDescriptionSpotlightProps> = (
  props,
) => {
  const BoardDescriptionSpotlight = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "board-description-spotlight" */ './BoardDescriptionSpotlight'
      ),
    { preload: false, namedImport: 'BoardDescriptionSpotlight' },
  );

  return (
    <Suspense fallback={props.target}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-smoothie',
          feature: 'Board Description Spotlight',
        }}
      >
        <ChunkLoadErrorBoundary fallback={props.target}>
          <BoardDescriptionSpotlight {...props} />
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </Suspense>
  );
};
